import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { reviews } from '../data/testimonials';
export function Testimonials() {
  return <section className="bg-stage water-glow-soft py-16 sm:py-20" aria-labelledby="reviews-title" data-id="element-244" data-mp="3fznsli0714zs">
      <div className="mx-auto max-w-6xl px-4" data-id="element-245" data-mp="3b0kmrvce2uqr">
        <h2 id="reviews-title" className="text-center text-3xl font-extrabold text-white sm:text-4xl" data-id="element-246" data-mp="3azt57ofmmxjh">
          Testimonials from educators using this collection
        </h2>
        <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-247" data-mp="31zmto83ho7my">
          {reviews.map(([initials, name, role, quote], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.15
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-col rounded-xl border border-silverEdge bg-navyPanel p-6 shadow-card" data-id="element-248" data-mp="2x1bk7yh3vz59" data-mpi={index}>
              <div className="flex text-silver" aria-label="5 out of 5 stars" data-id="element-249" data-mp="h4n4wev9c5ci">
                {Array.from({
              length: 5
            }, (_, star) => <StarIcon key={star} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-250" data-mp="780ktsar9ibj" />)}
              </div>
              <blockquote className="mt-4 flex-1 leading-relaxed text-silver" data-id="element-251" data-mp="c7wnno7pv3pi">“{quote}”</blockquote>
              <div className="mt-6 flex items-center gap-3 border-t border-silverEdge pt-4" data-id="element-252" data-mp="zxhc2mmn2t66">
                <span className="metal-surface flex h-10 w-10 shrink-0 items-center justify-center rounded-md text-sm font-extrabold text-navyDeep" data-id="element-253" data-mp="14uhe8mgdbbs0">
                  {initials}
                </span>
                <span data-id="element-254" data-mp="v4o5dt7m1arg">
                  <b className="block text-sm text-silverBright" data-id="element-255" data-mp="v3wjxb7q8tew">{name}</b>
                  <small className="text-xs text-silverDark" data-id="element-256" data-mp="1iu8yh4xh9oeg">{role}</small>
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}